import script from "./PartnerProjectFormStep5.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerProjectFormStep5.vue?vue&type=script&setup=true&lang=js"

import "./PartnerProjectFormStep5.vue?vue&type=style&index=0&id=6ed468f5&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ed468f5"]])

export default __exports__